import fetch from "../utils/fetch";

//上传版本
export const fetchUploadVersion = (body) =>
  fetch(`appVersion/upload`, {
    method: "post",
    body,
  });

//版本列表
export const fetchVersionList = (params) =>
  fetch(`appVersion/list`, {
    params,
  });

//是否启用
export const fetchIsOpen = (body) =>
  fetch(`appVersion`, {
    method: "put",
    body,
  });

//硬件版本列表
export const fetchHardwareVersionList = (body) =>
  fetch(`appVersion/hardware/list`, {
    params: body,
  });

//查询硬件位置
export const fetchHardwarePosition = () =>
  fetch(`appVersion/hardware/position/list`);

//上传硬件版本
export const fetchUploadHardwareVersion = (data) =>
  fetch(`appVersion/hardware`, {
    method: "put",
    data,
  });

//硬件启用禁用
export const fetchHardwareIsOpen = (body) =>
  fetch(`appVersion/hardware/activation`, {
    method: "put",
    body,
  });
